export default __webpack_public_path__ + "static/media/22.fc4820d4.png";